module.exports = __webpack_public_path__ + "static/media/watermelon.39f4cc90.svg";